const resumesData = [
  {
    title: "Frontend",
    placement: "one",
    downloadLink: "",
    techStack: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Material UI",
      "React",
      "Typescript",
      "Javascript",
    ],
  },
  {
    title: "Backend",
    placement: "two",
    downloadLink: "",
    techStack: [
      ".NET MVC",
      ".NET Core",
      "Entity Framework",
      "Auto Mapper",
      "NodeJS",
      "Express",
      "MySql",
      "Postgres",
      "SQLite",
    ],
  },
  {
    title: "QA Tester",
    placement: "three",
    downloadLink: "",
    techStack: [
      "XUNIT(C#)",
      "JUNIT(Java)",
      "React Testing Library",
      "Jest",
      "Playwright",
      "Selenium",
      "Embedded Test Tools",
    ],
  },
  {
    title: "IT Admin",
    placement: "four",
    downloadLink: "",
    techStack: [
      "Azure",
      "AWS",
      "Heroku",
      "Netlify",
      "FlyIO",
      "Docker",
      "Routers",
      "Servers",
      "Powershell Scripts",
    ],
  },
];

export { resumesData };
